"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileAppenderLoadError = exports.LazyComponentLoadingError = exports.ListenerCallbackError = exports.UnregisteredComponentUsedError = exports.UnregisteredMethodInvokedError = exports.ReactModuleContainerError = void 0;
var tslib_1 = require("tslib");
var ReactModuleContainerError = /** @class */ (function (_super) {
    tslib_1.__extends(ReactModuleContainerError, _super);
    function ReactModuleContainerError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = _this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(_this, _this.constructor);
        }
        else {
            _this.stack = new Error(message).stack;
        }
        return _this;
    }
    return ReactModuleContainerError;
}(Error));
exports.ReactModuleContainerError = ReactModuleContainerError;
var UnregisteredMethodInvokedError = /** @class */ (function (_super) {
    tslib_1.__extends(UnregisteredMethodInvokedError, _super);
    function UnregisteredMethodInvokedError(methodName) {
        var _this = _super.call(this, "ModuleRegistry.invoke ".concat(methodName, " used but not yet registered")) || this;
        _this.name = 'UnregisteredMethodInvokedError';
        return _this;
    }
    return UnregisteredMethodInvokedError;
}(ReactModuleContainerError));
exports.UnregisteredMethodInvokedError = UnregisteredMethodInvokedError;
var UnregisteredComponentUsedError = /** @class */ (function (_super) {
    tslib_1.__extends(UnregisteredComponentUsedError, _super);
    function UnregisteredComponentUsedError(componentId) {
        var _this = _super.call(this, "ModuleRegistry.component ".concat(componentId, " used but not yet registered")) || this;
        _this.name = 'UnregisteredComponentUsedError';
        return _this;
    }
    return UnregisteredComponentUsedError;
}(ReactModuleContainerError));
exports.UnregisteredComponentUsedError = UnregisteredComponentUsedError;
var ListenerCallbackError = /** @class */ (function (_super) {
    tslib_1.__extends(ListenerCallbackError, _super);
    function ListenerCallbackError(methodName, error) {
        var _this = _super.call(this, "Error in listener callback of module registry method: ".concat(methodName)) || this;
        _this.name = 'ListenerCallbackError';
        _this.stack += error.stack;
        _this.originalError = error;
        return _this;
    }
    return ListenerCallbackError;
}(ReactModuleContainerError));
exports.ListenerCallbackError = ListenerCallbackError;
var LazyComponentLoadingError = /** @class */ (function (_super) {
    tslib_1.__extends(LazyComponentLoadingError, _super);
    function LazyComponentLoadingError(component, error) {
        var _this = _super.call(this, "Error loading moduleRegistry lazy component ".concat(component)) || this;
        _this.name = 'LazyComponentLoadingError';
        _this.stack += error.stack;
        _this.originalError = error;
        return _this;
    }
    return LazyComponentLoadingError;
}(ReactModuleContainerError));
exports.LazyComponentLoadingError = LazyComponentLoadingError;
var FileAppenderLoadError = /** @class */ (function (_super) {
    tslib_1.__extends(FileAppenderLoadError, _super);
    function FileAppenderLoadError(fileUrl) {
        var _this = _super.call(this, "FilesAppender failed to load file ".concat(fileUrl)) || this;
        _this.name = 'FileAppenderLoadError';
        return _this;
    }
    return FileAppenderLoadError;
}(ReactModuleContainerError));
exports.FileAppenderLoadError = FileAppenderLoadError;
//# sourceMappingURL=ReactModuleContainerErrors.js.map